import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

function createEditEventByIdQueryKey(eventId) {
  return [QUERY_KEYS.clinics, eventId];
}

export function useEditEventByIdQuery({ eventId }, options = {}) {
  return useQuery(
    createEditEventByIdQueryKey(eventId),
    () => http.get(HTTP_ENDPOINTS.getEditEventById(eventId)),
    options,
  );
}
